/* Card System 2.0 motion: ATC button state machine + entrance stagger.
 * ATC transport stays Empire's own quick-buy handler; this file only
 * layers UI states around it, keyed off Empire's cartcount:update (success)
 * and addToCartFlyout:error (failure) events, with an 8s timeout fallback.
 * State classes live on .productitem--actions (a stable wrapper), not on
 * the button itself: Empire's AddToCartFlyout saves/restores the button's
 * own className and text mid-flight, which wipes any classes or text set
 * directly on the button. State text renders via CSS pseudo-content keyed
 * off the wrapper classes, so no textContent mutation happens here.
 * Entrance stagger applies to grid cards only, never carousel cells
 * (Flickity owns transforms there). Respects prefers-reduced-motion.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---- ATC state machine ---- */
  var pendingWrap = null;
  var failTimer = null;

  function resetWrap(wrap) {
    if (!wrap) return;
    wrap.classList.remove('tc-atc--loading', 'tc-atc--success', 'tc-atc--error');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-buy]');
    if (!btn) return;
    var wrap = btn.closest('.productitem--actions');
    if (!wrap) return;
    if (pendingWrap) { clearTimeout(failTimer); resetWrap(pendingWrap); }
    pendingWrap = wrap;
    wrap.classList.add('tc-atc--loading');
    failTimer = setTimeout(function () {
      wrap.classList.remove('tc-atc--loading');
      wrap.classList.add('tc-atc--error');
      setTimeout(function () { resetWrap(wrap); }, 1600);
      pendingWrap = null;
    }, 8000);
  });

  window.addEventListener('cartcount:update', function () {
    if (!pendingWrap) return;
    clearTimeout(failTimer);
    var wrap = pendingWrap;
    pendingWrap = null;
    wrap.classList.remove('tc-atc--loading');
    wrap.classList.add('tc-atc--success');
    setTimeout(function () { resetWrap(wrap); }, 1600);
  });

  document.addEventListener('addToCartFlyout:error', function () {
    if (!pendingWrap) return;
    clearTimeout(failTimer);
    var wrap = pendingWrap;
    pendingWrap = null;
    wrap.classList.remove('tc-atc--loading');
    wrap.classList.add('tc-atc--error');
    setTimeout(function () { resetWrap(wrap); }, 1600);
  });

  /* ---- Entrance stagger (grid cards only) ---- */
  if (reduceMotion || inEditor || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('tc-cards-js');

  var batchIndex = 0;
  var lastBatch = 0;
  var io = new IntersectionObserver(function (entries) {
    var now = performance.now();
    if (now - lastBatch > 400) batchIndex = 0;
    lastBatch = now;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var delay = Math.min(batchIndex, 5) * 60;
      batchIndex += 1;
      entry.target.style.setProperty('--tc-card-delay', delay + 'ms');
      entry.target.classList.add('tc-card-in');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.1 });

  function observeCards(root) {
    var cards = (root || document).querySelectorAll(
      '.productgrid--items .productgrid--item:not(.tc-card-in)'
    );
    cards.forEach(function (el) { io.observe(el); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    observeCards(document);
    new MutationObserver(function () { observeCards(document); })
      .observe(document.body, { childList: true, subtree: true });
  });
})();
